import React from 'react';
import AdvanceWizard from '../ui-elements/advanced-wizard/advance-wizard';

const AvancedWizardPage = () => {
	return <AdvanceWizard />;
};

export default AvancedWizardPage;
